import script from "./TournamentCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./TournamentCard.vue?vue&type=script&setup=true&lang=ts"

import "./TournamentCard.vue?vue&type=style&index=0&id=3c7295af&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c7295af"]])

export default __exports__